import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  open(event) {
    const id = event.currentTarget.dataset.dialogId;
    event.currentTarget.closest("details")?.removeAttribute("open");
    const dialog = id && document.getElementById(id);
    if (!dialog) return;

    this.application
      .getControllerForElementAndIdentifier(dialog, "remove-intermediary-dialog")
      ?.reset();
    this.application
      .getControllerForElementAndIdentifier(dialog, "remove-facility-dialog")
      ?.reset();

    dialog.showModal();
  }

  closeDialog(event) {
    const id = event.currentTarget.dataset.dialogId;
    const dialog =
      (id && document.getElementById(id)) || event.currentTarget.closest("dialog");
    dialog?.close();
  }
}
